import { Table, Row, Collapse, Col, Flex, Typography, Space } from "antd";
// import { Label } from "../TestAndLabelLinks";
import Title from "antd/es/skeleton/Title";
import { MathJax } from 'better-react-mathjax';
// import { mostRestrictiveCheck, AEcompare, AEL, collectedEmission, excess, passFail } from "../../pages/Loginv2/Calculators/Results/MPE_AEL_Results/LaserClassResultsV2";
import { mostRestrictiveCheckANSI, passFailANSI, AEcompareANSI } from "./ANSILaserClassResults";

export function ANSIAELTab(props, condition) {
    // console.log("tab", props)

    return (
        <>
            <Space direction="vertical" size="large" style={{ width: "100%" }}>
                {AELTable(props, 1)}
                {props?.results?.laserOperation?.includes("FO") ?
                    AELTable(props, 2) : null
                }
                {AELTable(props, 2)}
            </Space>
        </>
    )
}

function AELTable(props, condition) {
    const { Text, Title } = Typography

    return (
        <Table
            title={(() => <Row justify="center" style={{ fontSize: '15px', fontWeight: "bold" }}>Condition {condition} Class {props.class.toUpperCase()}</Row>)}
            pagination={false}
            bordered
            scroll={{ x: 600 }}
            justify="center"
            columns={[
                {
                    key: 1,
                    title: "",
                    dataIndex: "class",
                    align: "center"
                },
                {
                    key: 2,
                    title: "Accessible Emission Limit",
                    dataIndex: "aelSingle",
                    align: "center",
                    children: props?.laserOperation === "repetitivelyPulsed_ansi" || props.results?.laserOperation === "FO_RP"
                        ? [
                            {
                                key: 1,
                                title: <Text strong>AEL <sub>single </sub></Text>,
                                dataIndex: "aelSingle"
                            },
                            {
                                key: 2,
                                title: <Text strong>AEL <sub>s.p. Train </sub></Text>,
                                dataIndex: "aelPulseTrain"
                            },
                            {
                                key: 3,
                                title: <Text strong>AEL <sub>s.p.T</sub></Text>,
                                dataIndex: "aelSPT"
                            },
                        ]
                        : []
                },
                ...(props?.laserOperation === "repetitivelyPulsed_ansi" || props?.results?.laserOperation === "FO_RP"
                    ? [
                        {
                            key: 4,
                            title: <Text strong>AEL <sub>T</sub></Text>,
                            dataIndex: "aelTimeBase",
                            onCell: (record) => ({
                                style: {
                                    backgroundColor: record.aelTimeBase === "Critical" ? "#d9d9d9" : "white",
                                    color: record.aelTimeBase === "Critical" ? "gray" : "black",
                                },
                            }),
                        },
                    ]
                    : []),
                {
                    key: 3,
                    title: "Emission Hazard Value",
                    dataIndex: "safetyRatio",
                    align: "center"
                },
                {
                    key: 4,
                    title: "Pass/Fail",
                    dataIndex: "check",
                    align: "center"
                }
            ]}


            dataSource={[
                {
                    key: 1,
                    name: "accessibleEmission",
                    class: "Class " + props.class.toUpperCase(),
                    ...(props?.laserOperation === "repetitivelyPulsed_ansi" ?
                        {
                            aelSingle: <Text strong style={mostRestrictiveCheckANSI('single', [`class${props.class}`], props)} type={AEcompareANSI('single', [`class${props.class}`], props)}>{props.results[`condition${condition}`][`class${props.class}`]?.AEL?.single?.aelStandard?.pretty} </Text>,
                            aelPulseTrain: <Text strong style={mostRestrictiveCheckANSI('pulseTrain', [`class${props.class}`], props)} type={AEcompareANSI('pulseTrain', [`class${props.class}`], props)}>{props?.results[`condition${condition}`][`class${props.class}`]?.AEL?.pulseTrain?.pretty}</Text>,
                            aelSPT: <Text strong style={mostRestrictiveCheckANSI('SPT', [`class${props.class}`], props)} type={AEcompareANSI('SPT', [`class${props.class}`], props)}>{props.results[`condition${condition}`][`class${props.class}`]?.AEL?.SPT?.pretty}</Text>,
                            aelTimeBase: <Text>{props.results[`condition${condition}`][`class${props.class}`]?.AEL?.T?.aelStandard?.pretty}</Text>,
                        }
                        : {
                            aelSingle: <Text strong type={AEcompareANSI('single', [`class${props.class}`], props)}>{props.results[`condition${condition}`][`class${props.class}`]?.AEL?.single?.aelStandard?.pretty} </Text>
                        }
                    ),
                    safetyRatio: <Text strong type={passFailANSI([`class${props.class}`], props).style}>{props.results[`condition${condition}`][`class${props.class}`]?.EHV?.pretty}</Text>,
                    check: <Text strong type={passFailANSI([`class${props.class}`], props).style}>{props.results[`condition${condition}`][`class${props.class}`]?.P_F}</Text>
                },
                {
                    key: 2,
                    class: <Text strong>Accessible Emission</Text>,
                    aelSingle: ` ${props.results[`condition${condition}`].details.collectedEmission.joulesPretty} | ${props.results[`condition${condition}`].details.collectedEmission.wattsPretty}`

                }
            ]}
            footer={() => (
                <Collapse
                    size="small"
                    items={[
                        {
                            key: 1,
                            label: (
                                <Flex justify='center'>
                                    <Flex>
                                        <Text strong type="warning">More Details</Text>
                                    </Flex>
                                </Flex>
                            ),
                            children: (
                                <>
                                    <Row justify={"space-between"} style={{ width: "100%" }}>
                                        <Col lg={12} sm={24} justify={"center"}>
                                            <Table
                                                bordered
                                                style={{ width: '95%', justifySelf: "center" }}
                                                pagination={false}
                                                columns={[
                                                    {
                                                        key: 1,
                                                        title: "Correction Factor",
                                                        dataIndex: "name",
                                                        align: "right",
                                                        width: 10
                                                    },
                                                    {
                                                        key: 2,
                                                        title: "Value",
                                                        dataIndex: "value",
                                                        align: "center",
                                                        width: 10
                                                    }
                                                ]}
                                                dataSource={[
                                                    // {
                                                    //     key: 1,
                                                    //     name: "C5",
                                                    //     value: props.class === "2" ? [
                                                    //         Math.floor(props.laserClass.myC5v2.condition1_Class2 * 100) / 100
                                                    //     ] : props.class === "3r" ?  Math.floor(props.laserClass.myC5v2[`condition${condition}_Class3R`] * 100) / 100
                                                    //     : Math.floor(props.laserClass.myC5v2[`condition${condition}`] * 100) / 100

                                                    // },
                                                    // {
                                                    //     key: 2,
                                                    //     name: "C6 (t=Timebase)",
                                                    //     value: props.laserClass.C6[`condition${condition}`].timebase

                                                    // },
                                                    // {
                                                    //     key: 3,
                                                    //     name: "C6 (t=pulse duartion)",
                                                    //     value: props.laserClass?.C6[`condition${condition}`]?.extendedFixed
                                                    // },
                                                    // ...props?.results[`condition${condition}`]?.details?.correctionFactors.filter((cf) => cf.val !== null)
                                                    // .map((item, index) => ({
                                                    //     key: 4 + index, 
                                                    //     name: item.name,
                                                    //     value: Math.floor(item.val* 100) / 100
                                                    // })),
                                                    ...Object.entries(props?.results[`condition${condition}`]?.details?.correctionFactor || {})
                                                        .filter(([_, value]) => value?.num != null)
                                                        .map(([key, value], index) => ({
                                                            key: 4 + index,
                                                            name: key,
                                                            num: value.num,
                                                            value: value.pretty
                                                        })),
                                                    {
                                                        key: 0,
                                                        name: "CP",
                                                        value: props?.results[`condition${condition}`]?.details.myCP
                                                    },
                                                    ...["CE", "CG", "T2", "AlphaMin", "AlphaMax", "Gamma"]
                                                        .map((key, index) => {
                                                            const value = props?.results[`condition${condition}`]?.details?.extendedCorrectionFactor?.[key];
                                                            return value?.num != null
                                                                ? {
                                                                    key: 10 + index,
                                                                    name: key,
                                                                    num: value.num,
                                                                    value: value.pretty
                                                                }
                                                                : null;
                                                        })
                                                        .filter(Boolean),

                                                ]}
                                            />
                                        </Col>
                                        <Col lg={12} sm={24}>
                                            <Table
                                                style={{ width: '95%' }}
                                                pagination={false}
                                                bordered
                                                columns={[
                                                    {
                                                        key: 1,
                                                        title: "Measurement aperture diameters and measurement distances",
                                                        dataIndex: "name",
                                                        align: "right",
                                                    },
                                                    {
                                                        key: 2,
                                                        title: "Value",
                                                        dataIndex: "value",
                                                        align: "center",
                                                        width: "130px"
                                                    }
                                                ]}
                                                dataSource={[
                                                    {
                                                        key: 1,
                                                        name: 'Aperture Stop',
                                                        value: `${props?.results[`condition${condition}`]?.details?.measurementAperture?.apertureDiameter} mm` || "-"
                                                    },
                                                    {
                                                        key: 2,
                                                        name: 'Aperture Distance',
                                                        value: `${props?.results[`condition${condition}`]?.details?.measurementAperture?.measurementDistance} cm` || "-"
                                                    },
                                                    {
                                                        key: 3,
                                                        name: 'Angular Subtense',
                                                        value: props.results[`condition${condition}`]?.angularSubtense !== null ? props.results[`condition${condition}`]?.angularSubtense : '-'
                                                    },
                                                ]}
                                            />
                                        </Col>
                                    </Row>
                                    <br />
                                    <Row >
                                        <Col lg={12} sm={24}>
                                            <Table
                                                bordered
                                                style={{ width: '95%' }}
                                                pagination={false}
                                                columns={[
                                                    {
                                                        key: 1,
                                                        title: "Timebases",
                                                        dataIndex: "name",
                                                        align: "right",
                                                        width: 10
                                                    },
                                                    {
                                                        key: 2,
                                                        title: "Value",
                                                        dataIndex: "value",
                                                        align: "center",
                                                        width: 10
                                                    }
                                                ]}
                                                dataSource={[
                                                    {
                                                        key: 1,
                                                        name: "T",
                                                        value: props.results[`condition${condition}`]?.details.timeBase?.actual
                                                        // props.laserClass[`condition${condition}`].details.collectedEmission.joulesPretty}
                                                    },
                                                    ...props?.laserOperation.includes("cw") ? [] : [
                                                        {
                                                            key: 2,
                                                            name: "Ti",
                                                            value: props.results[`condition${condition}`]?.details.T_i + "s"

                                                        },
                                                    ],
                                                    // {
                                                    //     key: 3,
                                                    //     name: "T2",
                                                    //     value: props?.laserClass[`condition${condition}`]?.T2?.toFixed(1)
                                                    // },
                                                    ...props?.laserOperation.includes("cw") ? [] : [
                                                        {
                                                            key: 4,
                                                            name: "Pulse Duration",
                                                            value: props.results[`condition${condition}`]?.details.timeBase?.value

                                                        }
                                                    ],
                                                ]}
                                            />
                                        </Col>
                                        {props?.laserOperation === "repetitivelyPulsed_ansi" || props?.laserOperation === "FO_RP" ?
                                            <Col lg={12} sm={24}>
                                                <Table
                                                    bordered
                                                    style={{ width: '95%' }}
                                                    pagination={false}
                                                    columns={[
                                                        {
                                                            key: 1,
                                                            title: "Number of Pulses",
                                                            dataIndex: "name",
                                                            align: "right",
                                                            width: 10
                                                        },
                                                        {
                                                            key: 2,
                                                            title: "Value",
                                                            dataIndex: "value",
                                                            align: "center",
                                                            width: 10
                                                        }
                                                    ]}
                                                    dataSource={[
                                                        {
                                                            key: 1,
                                                            name: <Text>N <sub>T</sub></Text>,
                                                            value: props.results[`condition${condition}`]?.details?.numberOfPulses.N

                                                        },
                                                        {
                                                            key: 2,
                                                            name: <Text>N <sub>T2</sub></Text>,
                                                            // value:props.laserClass[`condition${condition}`]?.NT2

                                                        },
                                                    ]}
                                                />
                                            </Col>
                                            : null
                                        }
                                    </Row>
                                </>
                            )
                        }
                    ]}
                />
            )}
        />
    )
}

